/* Zenith Floating Cart: Final Independent Version */
(function () {
  if (window.__ZFC_LOADED__) return;
  window.__ZFC_LOADED__ = true;

 // ==============================================
  // ▼ 設定
  // ==============================================
  const freeShipYen = 4900; 

  // 1. トップページ用 (ワイン診断)
  const promoImg  = 'https://cdn.shopify.com/s/files/1/0667/1433/7395/files/wine-diagnosis.png?v=1773878627'; 
  const promoLink = 'https://otomorich.jp/pages/wine-finder'; 

  // 2. 商品詳細ページ用 (LINEバナー)
  const productPromoImg  = ''; 
  const productPromoLink = ''; 
  // ==============================================

  // 1. 画像バナー (独立生成)
  let imgHtml = '';
  const path = window.location.pathname;

  let currentImg = '';
  let currentLink = '';

  // 判定ロジック
  if (path === '/') {
    // トップページなら「ワイン診断」を表示
    currentImg = promoImg;
    currentLink = promoLink;
  } else if (path.includes('/products/')) {
    // 商品詳細ページなら「LINE」を表示
    currentImg = productPromoImg;
    currentLink = productPromoLink;
  }

  // HTML生成
  if (currentImg) {
    if (currentLink) {
      imgHtml = `<a href="${currentLink}" class="z-promo-banner" id="zPromo"><img src="${currentImg}" alt="お知らせ"></a>`;
    } else {
      imgHtml = `<div class="z-promo-banner" id="zPromo"><img src="${currentImg}" alt="お知らせ"></div>`;
    }
  }

  // 2. 送料無料テキスト (独立生成)
  const textHtml = `
    <div class="z-free-ship" id="zFreeShip" role="status" aria-live="polite">
      <div class="z-bar" aria-hidden="true"><span id="zFreeShipBar"></span></div>
      <p>
        <span class="z-left" id="zFreeShipText">あと — 円で送料無料</span>
        <span class="z-ok">🎉 送料無料です！</span>
      </p>
    </div>
  `;

  // 3. カートボタン (独立生成)
  const btnHtml = `
    <button type="button" class="z-floating-cart" id="zCartBtn"
      aria-controls="CartDrawer" aria-label="カートを開閉">
      <svg viewBox="0 0 24 24" aria-hidden="true">
        <path fill="currentColor" d="M7 18a2 2 0 1 0 0 4 2 2 0 0 0 0-4m10 0a2 2 0 1 0 0 4 2 2 0 0 0 0-4M4 4h2.2l2.1 9.4a3 3 0 0 0 2.9 2.3h7.6a3 3 0 0 0 2.9-2.2L24 7H7.3l-.5-2H4z"/>
      </svg>
      <span class="z-cart-badge" id="zCartBadge">0</span>
    </button>
  `;

  // まとめてbody直下に注入（グループ化なし）
  if (!document.getElementById('zCartBtn')) {
    document.body.insertAdjacentHTML('beforeend', imgHtml + textHtml + btnHtml);
  }

  // ===== 動作ロジック =====
  const btn = document.getElementById('zCartBtn');
  const badge = document.getElementById('zCartBadge');
  const banner = document.getElementById('zFreeShip');
  const bar = document.getElementById('zFreeShipBar');
  const text = document.getElementById('zFreeShipText');
  const fYen = v => new Intl.NumberFormat('ja-JP').format(v);

  async function fetchCart() {
    try {
      const res = await fetch('/cart.js', { credentials: 'same-origin' });
      if (!res.ok) throw new Error('fetch failed');
      return await res.json();
    } catch (e) { return null; }
  }

  function updateUI(cart) {
    if (!cart) return;
    const count = cart.item_count || 0;
    badge.textContent = count;
    badge.style.display = count > 0 ? 'inline-block' : 'none';
    const totalYen = Math.round((cart.total_price || 0) / 100);
    const need = Math.max(0, freeShipYen - totalYen);
    const ratio = Math.max(0, Math.min(1, totalYen / freeShipYen));
    bar.style.width = (ratio * 100).toFixed(1) + '%';
    if (need <= 0) {
      banner.classList.add('z-done');
      banner.setAttribute('aria-label', '送料無料です');
    } else {
      banner.classList.remove('z-done');
      text.textContent = `あと ${fYen(need)}円で送料無料`;
      banner.setAttribute('aria-label', text.textContent);
    }
  }

  function toggleDrawer() {
    const d = document.querySelector('cart-drawer');
    const overlay = document.querySelector('.drawer__overlay, #CartDrawer-Overlay');
    let isOpen = false;
    if (d && (d.hasAttribute('open') || d.classList.contains('drawer--is-open'))) isOpen = true;
    if (document.getElementById('CartDrawer-Overlay') && getComputedStyle(document.getElementById('CartDrawer-Overlay')).visibility !== 'hidden') isOpen = true;
    if (isOpen) {
      if (overlay) overlay.click();
      else if (d && typeof d.close === 'function') d.close();
    } else {
      if (d && typeof d.open === 'function') d.open();
    }
  }
  btn && btn.addEventListener('click', toggleDrawer);

  fetchCart().then(updateUI);
  const _origFetch = window.fetch;
  window.fetch = async function (...args) {
    const res = await _origFetch.apply(this, args);
    try {
      const url = (typeof args[0] === 'string' ? args[0] : (args[0] && args[0].url)) || '';
      if (/\/cart(\/add|\/change|\/update|\/clear|\.js)/.test(url)) setTimeout(() => { fetchCart().then(updateUI); }, 80);
    } catch (e) {}
    return res;
  };
  const d = document.querySelector('cart-drawer');
  if (d) new MutationObserver(() => fetchCart().then(updateUI)).observe(d.querySelector('.js-contents')||d, {childList:true, subtree:true});
  document.addEventListener('visibilitychange', () => { if(!document.hidden) fetchCart().then(updateUI); });
})();